import Lottie from 'react-lottie';
import Loader from './loader.json';

export default function LottieAnimation({ statusText = 'Loading', size = 'normal', backgroundColor }) {
  // Only create a modified animation if backgroundColor is explicitly provided
  const animationData = backgroundColor ? getColorizedAnimation(backgroundColor) : Loader;
  
  // Function to create a copy of the animation with the color applied
  function getColorizedAnimation(color) {
    // Deep clone the loader animation data
    const customLoader = JSON.parse(JSON.stringify(Loader));
    
    // Apply color to all stroke and fill elements in the animation
    const applyColorToLayers = (layers) => {
      if (!layers) return;
      
      layers.forEach(layer => {
        // Apply to all shape layers
        if (layer.ty === 4 && layer.shapes) {
          applyColorToShapes(layer.shapes);
        }
        
        // Handle nested shape groups
        if (layer.shapes) {
          applyColorToShapes(layer.shapes);
        }
      });
    };
    
    // Apply color to shapes and shape groups
    const applyColorToShapes = (shapes) => {
      if (!shapes) return;
      
      shapes.forEach(shape => {
        // Handle shape groups
        if (shape.it) {
          applyColorToShapes(shape.it);
        }
        
        // Apply to all strokes (ty: "st")
        if (shape.ty === "st" && shape.c && shape.c.k) {
          // Convert hex to RGB values (0-1 range)
          const rgbValues = hexToRgb(color);
          if (rgbValues) {
            shape.c.k = rgbValues;
          }
        }
        
        // Apply to all fills (ty: "fl")
        if (shape.ty === "fl" && shape.c && shape.c.k) {
          // Convert hex to RGB values (0-1 range)
          const rgbValues = hexToRgb(color);
          if (rgbValues) {
            shape.c.k = rgbValues;
          }
        }
      });
    };
    
    // Convert hex to RGB values (0-1 range)
    const hexToRgb = (hex) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? [
        parseInt(result[1], 16) / 255,
        parseInt(result[2], 16) / 255,
        parseInt(result[3], 16) / 255,
        1 // Alpha value
      ] : null;
    };
    
    // Apply color to all layers in the animation
    if (customLoader.layers) {
      applyColorToLayers(customLoader.layers);
    }
    
    return customLoader;
  }
  
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div role="presentation" className='flex flex-col items-center justify-center w-full h-full mt-[-20px]'>
      <Lottie options={defaultOptions} height={size === 'normal' ? 175 : 100} width={size === 'normal' ? 175 : 100} />
      {statusText && <p className={`status-text ${size === 'normal' ? 'mt-[-50px]' : 'mt-[-20px]'}`}>{statusText}</p>}
    </div>
  );
}
